import { Injectable } from '@angular/core';

import { BetslipPick } from 'packages/sports/common/betslip/core/picks/betslip-pick';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { GroupMinSelectionsPreCheckError } from '../../../../errors/general/group-pick-error';
import { MINIMUM_BET_BUILDER_SELECTIONS } from '../../betslip/min-selections-betbuilder.validator';
import { IPureLinearPickValidator } from '../validators';

@Injectable()
export class GroupPickMinSelectionsValidator implements IPureLinearPickValidator<GroupMinSelectionsPreCheckError> {
    validate(pick: BetslipPick): GroupMinSelectionsPreCheckError[] {
        const isInvalidBetBuilderPick = BaseBetslipGroupPick.isPick(pick) && pick.getLegs().length < MINIMUM_BET_BUILDER_SELECTIONS;

        return isInvalidBetBuilderPick ? [new GroupMinSelectionsPreCheckError(pick.id.toString())] : [];
    }
}
